export interface GoogleFont {
  family: string;
  category: 'sans-serif' | 'serif' | 'display' | 'handwriting' | 'monospace';
  variants: string[];
  popularityRank?: number;
}

export const GOOGLE_FONTS: GoogleFont[] = [
  // Made by the Braille Institute for people with low vision — the Low Vision theme uses it.
  {
    family: 'Atkinson Hyperlegible',
    category: 'sans-serif',
    variants: ['400', '700'],
  },
  {
    family: 'Inter',
    category: 'sans-serif',
    variants: ['300', '400', '500', '600', '700', '800', '900'],
    popularityRank: 1,
  },
  {
    family: 'Roboto',
    category: 'sans-serif',
    variants: ['100', '300', '400', '500', '700', '900'],
    popularityRank: 2,
  },
  {
    family: 'Montserrat',
    category: 'sans-serif',
    variants: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
    popularityRank: 3,
  },
  {
    family: 'Poppins',
    category: 'sans-serif',
    variants: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
    popularityRank: 4,
  },
  {
    family: 'Open Sans',
    category: 'sans-serif',
    variants: ['300', '400', '500', '600', '700', '800'],
    popularityRank: 5,
  },
  {
    family: 'Lato',
    category: 'sans-serif',
    variants: ['100', '300', '400', '700', '900'],
    popularityRank: 6,
  },
  {
    family: 'Raleway',
    category: 'sans-serif',
    variants: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
    popularityRank: 7,
  },
  {
    family: 'Nunito',
    category: 'sans-serif',
    variants: ['200', '300', '400', '500', '600', '700', '800', '900'],
    popularityRank: 8,
  },
  {
    family: 'Work Sans',
    category: 'sans-serif',
    variants: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
    popularityRank: 9,
  },
  {
    family: 'Ubuntu',
    category: 'sans-serif',
    variants: ['300', '400', '500', '700'],
    popularityRank: 10,
  },
  {
    family: 'Playfair Display',
    category: 'serif',
    variants: ['400', '500', '600', '700', '800', '900'],
    popularityRank: 11,
  },
  {
    family: 'Merriweather',
    category: 'serif',
    variants: ['300', '400', '700', '900'],
    popularityRank: 12,
  },
  {
    family: 'PT Sans',
    category: 'sans-serif',
    variants: ['400', '700'],
    popularityRank: 13,
  },
  {
    family: 'Oswald',
    category: 'sans-serif',
    variants: ['200', '300', '400', '500', '600', '700'],
    popularityRank: 14,
  },
  {
    family: 'Noto Sans',
    category: 'sans-serif',
    variants: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
    popularityRank: 15,
  },
  {
    family: 'Source Sans Pro',
    category: 'sans-serif',
    variants: ['200', '300', '400', '600', '700', '900'],
    popularityRank: 16,
  },
  {
    family: 'Quicksand',
    category: 'sans-serif',
    variants: ['300', '400', '500', '600', '700'],
    popularityRank: 17,
  },
  {
    family: 'DM Sans',
    category: 'sans-serif',
    variants: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
    popularityRank: 18,
  },
  {
    family: 'Rubik',
    category: 'sans-serif',
    variants: ['300', '400', '500', '600', '700', '800', '900'],
    popularityRank: 19,
  },
  {
    family: 'Mulish',
    category: 'sans-serif',
    variants: ['200', '300', '400', '500', '600', '700', '800', '900'],
    popularityRank: 20,
  },
  {
    family: 'Bebas Neue',
    category: 'display',
    variants: ['400'],
    popularityRank: 21,
  },
  {
    family: 'Karla',
    category: 'sans-serif',
    variants: ['200', '300', '400', '500', '600', '700', '800'],
    popularityRank: 22,
  },
  {
    family: 'Outfit',
    category: 'sans-serif',
    variants: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
    popularityRank: 23,
  },
  {
    family: 'Manrope',
    category: 'sans-serif',
    variants: ['200', '300', '400', '500', '600', '700', '800'],
    popularityRank: 24,
  },
  {
    family: 'Jost',
    category: 'sans-serif',
    variants: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
    popularityRank: 25,
  },
  {
    family: 'Lora',
    category: 'serif',
    variants: ['400', '500', '600', '700'],
    popularityRank: 26,
  },
  {
    family: 'Barlow',
    category: 'sans-serif',
    variants: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
    popularityRank: 27,
  },
  {
    family: 'Figtree',
    category: 'sans-serif',
    variants: ['300', '400', '500', '600', '700', '800', '900'],
    popularityRank: 28,
  },
  {
    family: 'Space Grotesk',
    category: 'sans-serif',
    variants: ['300', '400', '500', '600', '700'],
    popularityRank: 29,
  },
  {
    family: 'IBM Plex Sans',
    category: 'sans-serif',
    variants: ['100', '200', '300', '400', '500', '600', '700'],
    popularityRank: 30,
  },
  {
    family: 'Plus Jakarta Sans',
    category: 'sans-serif',
    variants: ['200', '300', '400', '500', '600', '700', '800'],
    popularityRank: 31,
  },
  {
    family: 'Heebo',
    category: 'sans-serif',
    variants: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
    popularityRank: 32,
  },
  {
    family: 'Red Hat Display',
    category: 'sans-serif',
    variants: ['300', '400', '500', '600', '700', '800', '900'],
    popularityRank: 33,
  },
  {
    family: 'Cabin',
    category: 'sans-serif',
    variants: ['400', '500', '600', '700'],
    popularityRank: 34,
  },
  {
    family: 'Lexend',
    category: 'sans-serif',
    variants: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
    popularityRank: 35,
  },
  {
    family: 'JetBrains Mono',
    category: 'monospace',
    variants: ['100', '200', '300', '400', '500', '600', '700', '800'],
    popularityRank: 36,
  },
  {
    family: 'Fira Sans',
    category: 'sans-serif',
    variants: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
    popularityRank: 37,
  },
  {
    family: 'Oxygen',
    category: 'sans-serif',
    variants: ['300', '400', '700'],
    popularityRank: 38,
  },
  {
    family: 'Sora',
    category: 'sans-serif',
    variants: ['100', '200', '300', '400', '500', '600', '700', '800'],
    popularityRank: 39,
  },
  {
    family: 'Public Sans',
    category: 'sans-serif',
    variants: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
    popularityRank: 40,
  },
  {
    family: 'Epilogue',
    category: 'sans-serif',
    variants: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
    popularityRank: 41,
  },
  {
    family: 'Crimson Text',
    category: 'serif',
    variants: ['400', '600', '700'],
    popularityRank: 42,
  },
  {
    family: 'Spectral',
    category: 'serif',
    variants: ['200', '300', '400', '500', '600', '700', '800'],
    popularityRank: 43,
  },
  {
    family: 'EB Garamond',
    category: 'serif',
    variants: ['400', '500', '600', '700', '800'],
    popularityRank: 44,
  },
  {
    family: 'Caveat',
    category: 'handwriting',
    variants: ['400', '500', '600', '700'],
    popularityRank: 45,
  },
  {
    family: 'Dancing Script',
    category: 'handwriting',
    variants: ['400', '500', '600', '700'],
    popularityRank: 46,
  },
  {
    family: 'Pacifico',
    category: 'handwriting',
    variants: ['400'],
    popularityRank: 47,
  },
  {
    family: 'Righteous',
    category: 'display',
    variants: ['400'],
    popularityRank: 48,
  },
  {
    family: 'Alfa Slab One',
    category: 'display',
    variants: ['400'],
    popularityRank: 49,
  },
  {
    family: 'Indie Flower',
    category: 'handwriting',
    variants: ['400'],
    popularityRank: 50,
  },
];

export function getFontCssFamily(fontFamily: string): string {
  return `'${fontFamily}', sans-serif`;
}

export function getGoogleFontUrl(fontFamily: string, weights: string[] = ['400', '500', '600', '700']): string {
  const font = GOOGLE_FONTS.find(f => f.family === fontFamily);
  if (!font) return '';

  const weightString = weights.join(';');
  const familyParam = fontFamily.replace(/ /g, '+');

  return `https://fonts.googleapis.com/css2?family=${familyParam}:wght@${weightString}&display=swap`;
}
